import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Tag = forwardRef<SVGSVGElement | null, IconFilledProps>(function Tag({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.25 5.25C2.25 3.59315 3.59315 2.25 5.25 2.25H9.56802C10.3637 2.25 11.1267 2.56607 11.6893 3.12868L21.2705 12.7098C22.1898 13.6291 22.4564 15.0989 21.698 16.2573C20.2793 18.4242 18.4242 20.2793 16.2573 21.698C15.0989 22.4564 13.6291 22.1898 12.7098 21.2705L3.12868 11.6893C2.56607 11.1267 2.25 10.3637 2.25 9.56802V5.25ZM5.25 3.75C4.42157 3.75 3.75 4.42157 3.75 5.25V9.56802C3.75 9.96584 3.90804 10.3474 4.18934 10.6287L13.7705 20.2098C14.2484 20.6878 14.9408 20.767 15.4357 20.443C17.4299 19.1374 19.1374 17.4299 20.443 15.4357C20.767 14.9408 20.6878 14.2484 20.2098 13.7705L10.6287 4.18934C10.3474 3.90804 9.96584 3.75 9.56802 3.75H5.25ZM5.25 6C5.25 5.58579 5.58579 5.25 6 5.25H6.0075C6.42171 5.25 6.7575 5.58579 6.7575 6V6.0075C6.7575 6.42171 6.42171 6.7575 6.0075 6.7575H6C5.58579 6.7575 5.25 6.42171 5.25 6.0075V6Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.25 2.25C3.59315 2.25 2.25 3.59315 2.25 5.25V9.56802C2.25 10.3637 2.56607 11.1267 3.12868 11.6893L12.7098 21.2705C13.6291 22.1898 15.0989 22.4564 16.2573 21.698C18.4242 20.2793 20.2793 18.4242 21.698 16.2573C22.4564 15.0989 22.1898 13.6291 21.2705 12.7098L11.6893 3.12868C11.1267 2.56607 10.3637 2.25 9.56802 2.25H5.25ZM6.375 7.5C6.99632 7.5 7.5 6.99632 7.5 6.375C7.5 5.75368 6.99632 5.25 6.375 5.25C5.75368 5.25 5.25 5.75368 5.25 6.375C5.25 6.99632 5.75368 7.5 6.375 7.5Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'tag-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Tag;
